// authentication.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Preferences } from '@capacitor/preferences';

const TOKEN_KEY = 'auth-token';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  authenticationState = new BehaviorSubject<boolean>(false);

  constructor() {
    this.loadToken();
  }

  private async loadToken() {
    const { value } = await Preferences.get({ key: TOKEN_KEY });
    console.log('🔍 TOKEN al iniciar:', value);
    this.authenticationState.next(!!value);
  }

  async login(data: any) {
    const value = typeof data === 'string' ? data : JSON.stringify(data);
    await Preferences.set({ key: TOKEN_KEY, value });
    const { value: saved } = await Preferences.get({ key: TOKEN_KEY });
    console.log('✅ TOKEN guardado:', saved);
    this.authenticationState.next(!!saved);
  }

  async logout() {
    await Preferences.remove({ key: TOKEN_KEY });
    this.authenticationState.next(false);
  }

  isAuthenticated() {
    return this.authenticationState.value;
  }
}
